import { ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Component({
  template: '',
  selector: 'loop-base-mail-comment',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export abstract class BaseMailCommentComponent implements OnDestroy {
  @HostBinding('class.is-collapsed') @Input() isCollapsed: boolean = false;

  readonly mailCommentFullyLoaded$: ReplaySubject<void> = new ReplaySubject<void>();

  ngOnDestroy(): void {
    this.mailCommentFullyLoaded$.complete();
  }
}
